import { ParsedQuery } from 'query-string';
import { ProjectId, TaskId, TaskIdV2, UserType } from 'api/models';
import { Transformer } from 'hooks/use-hash';
import {
  parseTaskDrawerParam,
  stringifyTaskDrawerParam,
  TaskDrawerTab,
} from 'hooks/use-navigate-to-task';

type Show = ['show', ProjectId, TaskIdV2, TaskDrawerTab?];
type Invalid = ['invalid'];

export type TaskDrawerParams = Show | Invalid;

export const createTransformer = (props: {
  userType?: UserType;
}): Transformer<TaskDrawerParams> => ({
  from: (parsed) => {
    if (typeof parsed.task_drawer !== 'string') {
      return ['invalid'];
    }

    const groups = parseTaskDrawerParam(parsed.task_drawer);

    if (!groups) {
      return ['invalid'];
    }
    const { project_id, task_id } = groups;

    const tab = parsed.task_drawer_tab as TaskDrawerTab | undefined;

    switch (tab) {
      case TaskDrawerTab.Approvals:
        return !parsed?.ppi
          ? [
              'show',
              ProjectId(project_id),
              TaskIdV2(task_id),
              TaskDrawerTab.Approvals,
            ]
          : props.userType === UserType.CustomerPortalBot
          ? ['invalid']
          : [
              'show',
              ProjectId(project_id),
              TaskIdV2(task_id),
              TaskDrawerTab.Approvals,
            ];
      case TaskDrawerTab.Conversations:
      default:
        return !parsed?.ppi
          ? [
              'show',
              ProjectId(project_id),
              TaskIdV2(task_id),
              TaskDrawerTab.Conversations,
            ]
          : props.userType === UserType.CustomerPortalBot
          ? ['invalid']
          : [
              'show',
              ProjectId(project_id),
              TaskIdV2(task_id),
              TaskDrawerTab.Conversations,
            ];
    }
  },
  to: (params): ParsedQuery => {
    switch (params[0]) {
      case 'show': {
        const tab = params[3];

        if (tab) {
          return {
            task_drawer: stringifyTaskDrawerParam(
              TaskId(params[1][1], params[2][1]),
            ),
            task_drawer_tab: tab,
          };
        }

        return {
          task_drawer: stringifyTaskDrawerParam(
            TaskId(params[1][1], params[2][1]),
          ),
        };
      }
      default:
        return {
          task_drawer: null,
          task_drawer_tab: null,
          form_response_id: null,
        };
    }
  },
});
